import { Link } from "react-router-dom/cjs/react-router-dom";
import { Input, Label, Modal } from "reactstrap";
import { getSearchNameList } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";

const SelectEntityName = props => {

    const[modal_isOpen, setModalIsOpen] = useState(false);
    const [selectedEntity, setSelectedEntity] = useState(null);
    const dispatch = useDispatch();

    const { searchNameList } = useSelector(state => ({
        searchNameList: state.GeneralStatistics.searchNameList || [],
    }));

    const openEntityModal = (flag) => {
        if (!flag) setSelectedEntity(null);
        setModalIsOpen(flag);
    }

    const search = (value) => {
        dispatch(getSearchNameList({searchName: value}));
    }

    const entityConfirm = () => {
        if (selectedEntity && props.onEntitySelect) {
            props.onEntitySelect({ name: selectedEntity.name, targetGroupNo: selectedEntity.no });
        }
        setSelectedEntity(null);
        setModalIsOpen(false);
    }

    return(
        <>
            <div style={
                {display: 'flex', alignItems: 'center', gap: '2px', border: "1px solid #ddd", borderRadius: "4px", padding: "0px 4px 0px 0px",}
            }>
                <Input
                    className="form-control"
                    type="text"
                    readOnly
                    style={{border: "none", outline: "none", flex: 1,}}
                    onChange={() => { }}
                    value={props.correctEntityName ?? props.extractedName ?? ""}
                />
                <Link to="#" onClick={(e) => openEntityModal(true)}> 
                    <i className="uil uil-plus-square font-size-22"></i>
                </Link>
            </div>

            <Modal
            isOpen={modal_isOpen}
            toggle={() => {
                openEntityModal(false)
            }}
            scrollable={true}>
                <div className="modal-header" style={{ marginRight: "20px" }}>
                    <h5 className="modal-title mt-0" id="myModalLabel">
                        Select entity
                    </h5>
                    <div className="app-search" style={{ padding: '0' }}>
                        <div className="position-relative">
                            <input
                                type="text"
                                className="form-control"
                                style={{ border: "solid 1px" }}
                                placeholder="Search..."
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        search(e.target.value);
                                    }
                                }}
                            />
                            <span className="uil-search"></span>
                        </div>
                    </div>
                    <button
                        type="button"
                        onClick={() => {
                            openEntityModal(false)
                        }}
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                 <div className="modal-body">
                    {
                        searchNameList && searchNameList.length > 0 &&
                        searchNameList.map((c, index) => {
                            return (
                                <div className="form-check mb-2" key={c.no}>
                                    <input
                                        type="radio"
                                        className="form-check-input"
                                        name={props.radioName || "entityName"}
                                        id={c.no}
                                        checked={selectedEntity?.no === c.no}
                                        onChange={() => setSelectedEntity(c)}
                                    />
                                    <Label
                                        className="form-check-label"
                                        htmlFor={c.no}
                                    >
                                        {c.name}
                                    </Label>
                                </div>
                            )
                        })
                    }
                </div>
                <div className="modal-footer">
                    <button
                        type="button"
                        onClick={() => {
                            openEntityModal(false)
                        }}
                        className="btn btn-secondary waves-effect"
                        data-dismiss="modal"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        onClick={() => entityConfirm()}
                    >
                        Confirm
                    </button>
                </div>
            </Modal>
        </>
    )
}

export default SelectEntityName;